import { Component, computed, signal, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
  selector: 'app-frontend-share-socials',
  standalone: true,
  imports: [MatIconModule, MatTooltipModule, SvgIconComponent],
  templateUrl: './frontend-share-socials.component.html',
})
export class FrontendShareSocialsComponent {
  @ViewChild('tooltip') tooltip!: MatTooltip;

  shareFacebook = computed(() => {
    return (
      'https://www.facebook.com/sharer/sharer.php?u=' + window.location.href
    );
  });

  shareX = computed(() => {
    return (
      'https://twitter.com/intent/tweet?url=' +
      encodeURIComponent(window.location.href)
    );
  });

  shareWhatsapp = computed(() => {
    return (
      'https://api.whatsapp.com/send?text=' +
      encodeURIComponent(window.location.href)
    );
  });

  shareEmail = computed(() => {
    return 'mailto:?body=' + window.location.href;
  });

  shareLink = computed(() => {
    return window.location.href;
  });

  copyLinkText = signal($localize`Copy link`);

  copyLink() {
    navigator.clipboard.writeText(window.location.href);
    this.copyLinkText.set($localize`Link copied`);
    this.tooltip.show();

    setTimeout(() => {
      this.copyLinkText.set($localize`Copy link`);
    }, 5000);
  }
}
